import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { NoteService } from 'src/app/services/note.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-rate-note',
  templateUrl: './rate-note.component.html',
  styleUrls: ['./rate-note.component.scss']
})
export class RateNoteComponent implements OnInit {
  @Input() noteId;
  @Output() reloadNote: EventEmitter<any> = new EventEmitter();
  canRate = false;
  myRating: number;
  showRatingModal = false;

  constructor(private orderService: OrderService, private authService: AuthorizationService, private noteService: NoteService) { }

  ngOnInit(): void {
    const isLogin = this.authService.isLogin();
    if (isLogin) {
      this.orderService.checkNoteOrderedPayed(this.noteId).subscribe(response => {
        if (response.success) {
          this.canRate = response.data.canRate;
          if (response.data.myRating) {
            this.myRating = response.data.myRating;
          }
        }
      });
    }
  }

  openRateModal() {
    this.showRatingModal = true;
  }
  closeRateModal() {
    this.showRatingModal = false;
  }

  handleRate(value: number) {
    this.myRating = value;
  }

  submitRate() {
    const obj = {
      id: this.noteId,
      rate: this.myRating
    };
    this.noteService.rateNote(obj).subscribe(response => {
      if (response.success) {
        this.closeRateModal();
        this.reloadNote.emit();
      }
    });
  }

}
